export default "__VITE_ASSET__2b7021f3__"